















































































































import ChatControl from "@/components/admin/ChatControl.vue";
import PollControl from "@/components/admin/PollControl.vue";
import Users from "@/components/admin/Users.vue";
import Socket from "@/mixins/socket"
import { Vue, Component, Mixins } from "vue-property-decorator";

@Component({
  components: { ChatControl, PollControl, Users },
  mixins: [Socket]
})
export default class Dash extends Vue {
  created() {
    this.$store.commit("setAdmin", true);
    this.$store
      .dispatch("API_CALL", {
        method: "get",
        url: `/events/${this.$route.params.id}`,
        headers: {
          ["x-access-token"]: localStorage.adminToken
        }
      })
      .then((res) => {
        this.$store.commit("setEvent", res.data);
        this.socket.emit("join_event", res.data._id)
        this.socket.emit("refresh_statuses");
      })
  }

  saveEvent() {
    this.$store.dispatch("API_CALL", { method: "put", url: "/events/" + this.event._id, data: this.event }).then((res) => {
        this.$bvToast.toast("Event saved successfully.", {
          autoHideDelay: 3000,
          appendToast: false
        })
    })
  }

    get event(): any {
      return this.$store.state.event;
    }
    get socket(): any {
      return this.$store.state.socket;
    }
}

